import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Behance from '../../../SvgIcons/Behance';
import LazyImage from '../../../Layouts/LazyImage';
import Link from '../../../Layouts/ActiveLink';

const Projects = ({ data }) => {
  const classes = useStyle();

  const { title, sub, projects } = data;

  return (
    <Box my={{ xs: 5, md: 10 }}>
      <Box className={'text-center-md'} mb={{ xs: 6 }}>
        <Typography variant="h4" component="h2">
          {title}
        </Typography>
        <Typography variant="subtitle1">{sub}</Typography>
      </Box>

      {projects && (
        <Grid container spacing={3}>
          {projects.map((project, key) => (
            <Grid item xs={12} sm={6} key={key}>
              <Link target="_blank" href={project?.url}>
                <>
                  <div className="relative">
                    <LazyImage
                      radius={2}
                      sizes={sizes}
                      className={classes.projectImg}
                      src={`/images/courses/project/${project.img}`}
                    />
                    {project?.isBehance && (
                      <div className={classes.behance}>
                        <Behance fontSize="2rem" />
                      </div>
                    )}
                  </div>
                  <Typography variant="h5">{project.title}</Typography>
                  <Typography variant="subtitle1">{project.sub}</Typography>
                </>
              </Link>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

const sizes = {
  xxl: [574, 362, false],
};

export default Projects;

const useStyle = makeStyles((theme: any) => ({
  behance: {
    position: 'absolute',
    top: '14px',
    right: '14px',
    background: '#fff',
    borderRadius: '50%',
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  projectImg: { marginBottom: theme.spacing(1), height: '207px' },
  [theme.breakpoints.up('md')]: {
    projectImg: { height: '362px' },
  },
}));
